import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const centerResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getCenter(to.params.id as string);
        to.meta.center = res.data.data;
    } catch(error) {
        console.error('CENTER_RESOLVER_ERROR');
        return { name: 'SystemCenters' };
    }
}